import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.my.program.item');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const WizRoute: any;
declare const wiz: any;

@Component({
    selector: 'wiz-page-my-program-item',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.my.program.item/view.scss */
:host {
  display: block;
  min-height: 100%;
  background: #fafafa;
}`],
})
export class PageMyProgramItemComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public application_id: string = '';
    public tab: string = 'overview';
    public loaded: boolean = false;
    public data: any = null;

    public moduleTypeMeta: any = {
        recruitment: { icon: '📢', label: '모집공고' },
        selection:   { icon: '✅', label: '선발' },
        diagnosis:   { icon: '📊', label: '기업진단' },
        education:   { icon: '📚', label: '교육' },
        mentoring:   { icon: '👥', label: '멘토링' },
        networking:  { icon: '🤝', label: '네트워킹' },
        demoday:     { icon: '💼', label: '데모데이' },
        company_mgmt:{ icon: '🏢', label: '기업관리' },
        reporting:   { icon: '📄', label: '보고' },
    };

    // diagnosis self form
    public diagModule: any = null;
    public diagTemplate: any = { scale: 7, categories: [] };
    public diagSummary: any = null;
    public diagForm: any = { items: [], overall_comment: '' };

    // hex
    public hexSize: number = 220;
    public hexCenter: number = 230;

    public async ngOnInit() {
        await this.service.init();
        this.application_id = WizRoute.segment.application_id;
        this.tab = WizRoute.segment.tab || 'overview';
        await this.load();
    }

    public async load() {
        this.loaded = false;
        await this.service.render();
        const r = await wiz.call('dashboard', { application_id: this.application_id });
        if (r.code != 200) {
            this.service.alert.show({ title: '접근 불가', message: r.data?.message || '오류', action: '확인' });
            this.service.href('/my/programs');
            return;
        }
        this.data = r.data.data;
        this.loaded = true;
        await this.service.render();
    }

    public moduleLabel(t: string): string {
        return (this.moduleTypeMeta[t]?.icon || '📋') + ' ' + (this.moduleTypeMeta[t]?.label || t);
    }

    public goTab(t: string) {
        this.tab = t;
        this.service.href(`/my/program/${this.application_id}/${t}`);
    }

    // ===== Diagnosis tab =====
    public openDiagnosis(d: any) {
        this.diagModule = d;
        this.diagTemplate = d.summary?.template || { scale: 7, categories: [] };
        this.diagSummary = d.summary;
        this._buildDiagForm();
    }

    private _buildDiagForm() {
        const items: any[] = [];
        for (const cat of (this.diagTemplate.categories || [])) {
            for (const it of (cat.items || [])) {
                items.push({ cat: cat.key, q: it.q, score: 0, comment: '' });
            }
        }
        this.diagForm = { items, overall_comment: '' };
    }

    public setDiagScore(idx: number, s: number) {
        this.diagForm.items[idx].score = s;
    }

    public diagScaleArray(): number[] {
        const n = Number(this.diagTemplate?.scale) || 7;
        const arr: number[] = [];
        for (let i = 1; i <= n; i++) arr.push(i);
        return arr;
    }

    public async submitSelfDiagnosis() {
        const empty = this.diagForm.items.filter((it: any) => !it.score).length;
        if (empty > 0) {
            this.service.alert.show({ title: '입력 필요', message: `${empty}개 항목의 점수가 누락되었습니다.`, action: '확인' });
            return;
        }
        const payload = {
            application_id: this.application_id,
            module_id: this.diagModule.module_id,
            program_id: this.data.application.program_id,
            items: this.diagForm.items,
            overall_comment: this.diagForm.overall_comment,
            status: 'submitted',
        };
        const r = await wiz.call('submit_self_diagnosis', { data: JSON.stringify(payload) });
        if (r.code != 200) {
            this.service.alert.show({ title: '제출 실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        this.service.alert.show({ title: '완료', message: '자가진단이 제출되었습니다.', action: '확인' });
        // refresh
        const sr = await wiz.call('diagnosis_summary', { application_id: this.application_id, module_id: this.diagModule.module_id });
        if (sr.code == 200) this.diagSummary = sr.data.data;
        this._buildDiagForm();
        await this.service.render();
    }

    // ===== Hex helpers =====
    public hasScores(t: string): boolean {
        const map = this.diagSummary?.scores?.[t];
        if (!map) return false;
        return Object.values(map).some((v: any) => Number(v) > 0);
    }

    public hexPoints(scoreMap: any): string {
        const cats = this.diagTemplate.categories || [];
        if (cats.length === 0) return '';
        const cx = this.hexCenter, cy = this.hexCenter;
        const r = this.hexSize;
        const max = this.diagTemplate.scale || 7;
        const pts: string[] = [];
        const n = cats.length;
        for (let i = 0; i < n; i++) {
            const v = Number(scoreMap[cats[i].key] || 0);
            const ratio = Math.max(0, Math.min(1, v / max));
            const angle = -Math.PI / 2 + (i * 2 * Math.PI / n);
            pts.push(`${(cx + Math.cos(angle) * r * ratio).toFixed(1)},${(cy + Math.sin(angle) * r * ratio).toFixed(1)}`);
        }
        return pts.join(' ');
    }

    public hexGridPolygons(): string[] {
        const cats = this.diagTemplate.categories || [];
        const out: string[] = [];
        const n = cats.length || 6;
        const cx = this.hexCenter, cy = this.hexCenter;
        const r = this.hexSize;
        for (const ratio of [0.25, 0.5, 0.75, 1.0]) {
            const pts: string[] = [];
            for (let i = 0; i < n; i++) {
                const angle = -Math.PI / 2 + (i * 2 * Math.PI / n);
                pts.push(`${(cx + Math.cos(angle) * r * ratio).toFixed(1)},${(cy + Math.sin(angle) * r * ratio).toFixed(1)}`);
            }
            out.push(pts.join(' '));
        }
        return out;
    }

    public hexLabelPos(i: number): { x: number, y: number, anchor: string } {
        const cats = this.diagTemplate.categories || [];
        const cx = this.hexCenter, cy = this.hexCenter;
        const r = this.hexSize + 22;
        const n = cats.length || 6;
        const angle = -Math.PI / 2 + (i * 2 * Math.PI / n);
        const x = cx + Math.cos(angle) * r;
        const y = cy + Math.sin(angle) * r;
        let anchor = 'middle';
        if (Math.cos(angle) > 0.3) anchor = 'start';
        else if (Math.cos(angle) < -0.3) anchor = 'end';
        return { x, y, anchor };
    }

    public diagnosisModules(): any[] {
        return this.data?.diagnosis || [];
    }
}

export default PageMyProgramItemComponent;